// extracted by mini-css-extract-plugin
export default {"section-divider":"SectionDivider_section-divider__JgAN5"};